const Footer = () => {

  return (
    <footer className="bg-white dark:bg-custom-900">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pb-12">
        <div className="pt-8">
          <div className="text-center">
            <p className="text-gray-600 dark:text-gray-400 text-sm">
              Designed and built with <span className="text-primary-500">❤</span> by Shejza Berisha © 2025
            </p>
          </div>
        </div>
      </div>
    </footer>
  )
}

export default Footer 